import { ReactComponent as LikedIcon } from "components/icons/likeIcon.svg";
import { ReactComponent as UnlikedIcon } from "components/icons/unliked.svg";
import "./LikeOverlay.scss";

interface LikeOverlayProps {
  isLiked?: boolean;
}

export const LikeOverlay = ({ isLiked }: LikeOverlayProps) => {
  return isLiked ? (
    <div className="likeOverlay liked">
      <LikedIcon />
    </div>
  ) : (
    <div className="likeOverlay unliked">
      <UnlikedIcon />
    </div>
  );
};
